/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this file will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener("DOMContentLoaded", function () {
    const el = document.querySelector('[data-price-off-type]');
    const variant =
      window?.Product?.currentVariant ||
      window?.theme?.currentVariant ||
      (window.VariantSelectors && window.VariantSelectors.currentVariant);

    if (el && variant?.compare_at_price) {
      const formatted = (variant.compare_at_price / 100).toLocaleString('sr-RS') + ' RSD';
      el.textContent = formatted;
    }
  });



  function isoToFlagEmoji(iso) {
    if (!iso) return '';
    return Array.from(iso.toUpperCase()).map(c => String.fromCodePoint(127397 + c.charCodeAt(0))).join('');
  }
  function paintCountryFlags(root = document) {
    root.querySelectorAll('.flag[data-iso]:not([data-done])').forEach(el => {
      el.textContent = isoToFlagEmoji(el.dataset.iso || '');
      el.dataset.done = '1';
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    paintCountryFlags();
    document.body.addEventListener('click', e => {
      const panel = e.target && e.target.closest('.disclosure__list-wrapper');
      if (panel) setTimeout(() => paintCountryFlags(panel), 0);
    });
  });



(function(){
  // Сербская кириллица → латиница (Гајева), с учетом диграфов
  const map = {
    'А':'A','Б':'B','В':'V','Г':'G','Д':'D','Ђ':'Đ','Е':'E','Ж':'Ž','З':'Z','И':'I','Ј':'J','К':'K',
    'Л':'L','Љ':'Lj','М':'M','Н':'N','Њ':'Nj','О':'O','П':'P','Р':'R','С':'S','Т':'T','Ћ':'Ć','У':'U',
    'Ф':'F','Х':'H','Ц':'C','Ч':'Č','Џ':'Dž','Ш':'Š',
    'а':'a','б':'b','в':'v','г':'g','д':'d','ђ':'đ','е':'e','ж':'ž','з':'z','и':'i','ј':'j','к':'k',
    'л':'l','љ':'lj','м':'m','н':'n','њ':'nj','о':'o','п':'p','р':'r','с':'s','т':'t','ћ':'ć','у':'u',
    'ф':'f','х':'h','ц':'c','ч':'č','џ':'dž','ш':'š'
  };
  const tr = s => s.replace(/[\u0400-\u04FF]/g, ch => map[ch] ?? ch);

  function transliterateIn(el){
    el.querySelectorAll('.country, .country-label').forEach(n=>{
      // уже латиница? пропускаем
      const t = n.textContent;
      if (/[А-ЩЉЊЋЏЭЮЯа-щљњћџэюя]/.test(t)) n.textContent = tr(t);
    });
  }

  // при открытии поповера
  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('.localization-form__select');
    if(!btn) return;
    setTimeout(()=>{
      document.querySelectorAll('.disclosure__list-wrapper').forEach(transliterateIn);
    }, 0);
  });

  // при вводе в поиск (фильтрация перерисовывает список)
  document.addEventListener('input', (e)=>{
    if(e.target && e.target.name === 'country_filter'){
      const wrap = e.target.closest('.disclosure__list-wrapper');
      if(wrap) requestAnimationFrame(()=>transliterateIn(wrap));
    }
  });

  // стартовая кнопка страны тоже латиницей
  window.addEventListener('DOMContentLoaded', ()=>{
    const header = document.querySelector('.theme__header__toolbar');
    if(header) transliterateIn(header);
  });
})();



// --- Mobile drawer: force-toggle Country selector ---
document.addEventListener('click', function (e) {
  // клик по "пилюле" страны в дровере
  const chip = e.target.closest(
    '.header__drawer .toolbar__currency .localization-form__select, ' +
    '.header__drawer .toolbar__currency .select-popout__toggle'
  );
  if (chip) {
    const wrap = chip.closest('.toolbar__currency');
    // закрываем язык, если открыт
    document.querySelectorAll('.header__drawer .toolbar__locale.is-open').forEach(n => n.classList.remove('is-open'));
    // переключаем страну
    wrap.classList.toggle('is-open');
    e.preventDefault();
    e.stopPropagation();
    return;
  }

  // клик вне панели — закрыть страну
  if (!e.target.closest('.header__drawer .toolbar__currency')) {
    document.querySelectorAll('.header__drawer .toolbar__currency.is-open')
      .forEach(n => n.classList.remove('is-open'));
  }
});

// при выборе страны (клик по элементу списка) — закрыть панель
document.addEventListener('click', function (e) {
  const option = e.target.closest('.header__drawer .toolbar__currency .disclosure__link, .header__drawer .toolbar__currency .select-popout__option');
  if (option) {
    const wrap = option.closest('.toolbar__currency');
    if (wrap) wrap.classList.remove('is-open');
  }
});


// --- Mobile drawer: live-search in Country sheet ---
document.addEventListener('input', function (e) {
  if (!e.target.matches('.header__drawer .toolbar__currency input[name="country_filter"]')) return;

  const q = e.target.value.trim().toLowerCase();
  const panel = e.target.closest('.disclosure__list-wrapper, .select-popout__list');
  if (!panel) return;

  panel.querySelectorAll('.disclosure__item').forEach(li => {
    const text = (li.textContent || '').toLowerCase();
    li.classList.toggle('hidden', q !== '' && !text.includes(q));
  });
});

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


